/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const audioCoverageStatsV1DataSchema = z.object({
  totalPublished: z.number(),
  withTitleAudio: z.number(),
  withDefinitionAudio: z.number(),
  totalWithUsageNotesText: z.number(),
  withUsageNotesAudio: z.number(),
  withAnyExampleAudio: z.number(),
  charsPerChallengeAvg: z.number(),
});

export type IAudioCoverageStatsV1Data = z.infer<typeof audioCoverageStatsV1DataSchema>;

export const getAudioCoverageStatsV1ResponseSchema = createApiResponseSchema(
  audioCoverageStatsV1DataSchema,
) as z.ZodSchema<IAPI<IAudioCoverageStatsV1Data>>;

export type IGetAudioCoverageStatsV1Response = IAPI<IAudioCoverageStatsV1Data>;
